import { useMerchant } from "@auth";
import {
  Dropdown,
  DropdownBody,
  DropdownButton,
  DropdownItem,
} from "@components";
import { cn } from "@utils";
import { MerchantSwitcher } from "./MerchantSwitcher";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { BoxArrowRight, Gear, LayoutSidebar } from "react-bootstrap-icons";
import { NavLink } from "react-router-dom";

export function SidebarHeader({
  collapsed = false,
  isCollapsed = false,
  onToggleCollapse,
  onNavigate,
}) {
  const { merchant } = useMerchant();

  // The row is pinned to the expanded width (min-w) so it never reflows while the rail animates
  // open — the sidebar clips the overflow, keeping the avatar anchored instead of the chevron/toggle
  // sweeping over it (which read as a flicker).
  return (
    <div className="flex h-12 min-w-[17.2rem] shrink-0 items-center border-b border-zinc-200">
      <Dropdown className="min-w-0 flex-1">
        {({ open }) => (
          <>
            <DropdownButton
              title={collapsed ? merchant?.name : undefined}
              className="flex h-12 w-full items-center overflow-hidden whitespace-nowrap font-semibold hover:bg-zinc-100 px-3"
            >
              <div className="w-7 h-7 mr-2 rounded-lg flex shrink-0 justify-center items-center text-white bg-blue-500 text-nowrap overflow-hidden">
                {merchant?.name?.[0]}
              </div>
              {!collapsed && (
                <>
                  <span className="truncate overflow-hidden whitespace-nowrap max-w-44">
                    {merchant?.name}
                  </span>
                  <ChevronDownIcon
                    className={cn(
                      "size-5 shrink-0 ml-auto",
                      open ? "rotate-180 text-zinc-500" : "text-zinc-400",
                    )}
                  />
                </>
              )}
            </DropdownButton>
            <DropdownBody className="left-2">
              <MerchantSwitcher />
              <NavLink to="/settings" onClick={onNavigate}>
                <DropdownItem closeOnComplete={true}>
                  <Gear className="mr-2" />
                  Settings
                </DropdownItem>
              </NavLink>
              <NavLink to="/logout">
                <DropdownItem closeOnComplete={true}>
                  <BoxArrowRight className="mr-2" />
                  Sign out
                </DropdownItem>
              </NavLink>
            </DropdownBody>
          </>
        )}
      </Dropdown>
      {!collapsed && onToggleCollapse && (
        <button
          type="button"
          onClick={onToggleCollapse}
          aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          className="mr-2 flex size-7 shrink-0 items-center justify-center rounded-md text-zinc-400 hover:bg-zinc-200 hover:text-zinc-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
        >
          <LayoutSidebar className="size-4" />
        </button>
      )}
    </div>
  );
}
